import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTrending2"><Path fillRule="evenodd" clipRule="evenodd" d="M13.1317 22.3965L18.1855 5.71898L20.9332 10.9503L22.2612 10.2528L17.8114 1.78109L12.8652 18.1036L8.09776 7.3768L4.9323 12.6526L2.90367 9.91954L1.69922 10.8136L5.06462 15.3475L7.89916 10.6233L13.1317 22.3965Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending2;
